import styled from 'styled-components';

export const ContainerFluid = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
